import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getUsers } from '../../../slices/authSlice';
import Main from '../../../components/Main/Main';
import DivSession from '../../../components/Main/DivSession';
import Title from '../../../components/Title';
import { TableFuncionarios } from '../../../components/Funcionarios/TableFuncionarios';
import usePageTitle from '../../../hook/usePageTitle';

const Funcionarios = () => {
  const dispatch = useDispatch();
  usePageTitle();

  useEffect(() => {
    dispatch(getUsers());
  }, []);

  return (
    <Main>
      <div>
        <Title>Gerenciar Funcionairos</Title>
      </div>
      <TableFuncionarios />
    </Main>
  );
};

export default Funcionarios;
